export const getYouTubeVideoId = (youtube, now = Date.now()) => {
    if (typeof youtube?.videoId !== 'string' || youtube.videoId.length !== 11 || !/^[A-Za-z0-9_-]{11}$/.test(youtube.videoId)) {
        return null;
    }
    const expiresAt = typeof youtube.expiresAt === 'string' ? Date.parse(youtube.expiresAt) : NaN;
    return Number.isFinite(expiresAt) && expiresAt > now ? youtube.videoId : null;
};

let iframeAPIRequest;

// Shared across openings; no YouTube request is made until a drawer is opened.
export const loadYouTubeIframeAPI = () => {
    if (window.YT?.Player) return Promise.resolve(window.YT);
    if (iframeAPIRequest) return iframeAPIRequest;

    iframeAPIRequest = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const previousReady = window.onYouTubeIframeAPIReady;
        const cleanup = () => {
            window.clearTimeout(timeout);
            if (window.onYouTubeIframeAPIReady === onReady) {
                window.onYouTubeIframeAPIReady = previousReady;
            }
        };
        const onFailure = () => {
            cleanup();
            script.remove();
            reject(new Error('YouTube player could not load'));
        };
        const onReady = () => {
            cleanup();
            resolve(window.YT);
            previousReady?.();
        };
        const timeout = window.setTimeout(onFailure, 15000);
        window.onYouTubeIframeAPIReady = onReady;
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        script.onerror = onFailure;
        document.head.appendChild(script);
    });
    iframeAPIRequest.catch(() => { iframeAPIRequest = null; });
    return iframeAPIRequest;
};
